module.exports = __webpack_public_path__ + "static/media/IconoTimer.1021f579.svg";